<template>
  <b-modal
    centered
    v-if="isOpen"
    v-model="isOpen"
    cancel-disabled
    hide-footer
    :title="`Credenciais de autenticação ClearSale`"
    size="lg"
  >
    <b-row>
      <b-col cols="12">
        <b-form-group label-for="appKey">
          <b-form-input
            placeholder="Digite o fingerprint (seu_app)"
            aria-describedby="appKey-help-block"
            v-model="fields.appKey"
            @input="validateFields"
            :state="
              !fields.appKey ? null : !errorMessages.appKey ? true : false
            "
          ></b-form-input>
          <b-form-invalid-feedback v-if="errorMessages.appKey" :state="false">
            Digite um fingerprint válido. O fingerprint é obrigatório.
          </b-form-invalid-feedback>
          <b-form-text v-else id="appKey-help-block">
            O fingerprint é o seu identificador de aplicação da ClearSale, a
            mesma deve ter sido enviada pela equipe de suporte da ClearSale ao
            seu e-mail.
          </b-form-text>
        </b-form-group>
        <b-form-group label-for="name">
          <b-form-input
            placeholder="Digite o nome do usuário"
            aria-describedby="name-help-block"
            v-model="fields.name"
            @input="validateFields"
            :state="!fields.name ? null : !errorMessages.name ? true : false"
          ></b-form-input>
          <b-form-invalid-feedback v-if="errorMessages.name" :state="false">
            Digite um nome válido. O nome é obrigatório.
          </b-form-invalid-feedback>
          <b-form-text v-else id="name-help-block">
            O nome é o seu usuário de integração da ClearSale, a mesma deve ter
            sido enviada pela equipe de suporte da ClearSale ao seu e-mail.
          </b-form-text>
        </b-form-group>
        <b-form-group label-for="password">
          <InputPassword
            placeholder="Digite a sua senha de integração"
            aria-describedby="password-help-block"
            :value.sync="fields.password"
            @update:value="validateFields"
            :state="
              !fields.password ? null : !errorMessages.password ? true : false
            "
          />
          <b-form-invalid-feedback v-if="errorMessages.password" :state="false">
            Digite uma senha válida. A senha é obrigatória.
          </b-form-invalid-feedback>
          <b-form-text v-else id="password-help-block">
            A senha é a chave de integração da ClearSale, a mesma deve ter sido
            enviada junto ao nome do usuário de integração ao seu e-mail.
          </b-form-text>
        </b-form-group>
      </b-col>
      <b-col class="mt-4">
        <b-button
          variant="outline-danger"
          @click="close"
          class="mr-2"
          :disabled="loading"
        >
          <i class="fas fa-times mr-2"></i> Fechar
        </b-button>
        <b-button
          variant="success"
          @click="save"
          class="mr-2"
          :disabled="loading"
        >
          <i class="fas fa-check mr-2"></i> Salvar credenciais
          <b-spinner small class="ml-2" v-if="loading"></b-spinner>
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import InputPassword from '@/components/Inputs/InputPassword.vue';
import { mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';

export default {
  name: 'CredentialsModal',
  emits: ['refresh'],
  mixins: [makeToast],
  computed: {
    ...mapState(['dadosUsuario']),
  },
  data() {
    return {
      isOpen: false,
      loading: false,
      fields: {
        name: '',
        password: '',
        appKey: '',
      },
      errorMessages: {
        name: '',
        password: '',
        appKey: '',
      },
    };
  },
  methods: {
    open() {
      this.isOpen = true;
      this.fields = {};
      this.errorMessages = {};
    },
    close() {
      this.isOpen = false;
      this.fields = {};
      this.errorMessages = {};
    },
    async save() {
      if (!this.validateFields()) {
        this.makeToast('Erro', 'Preencha os campos corretamente', 'danger');
        return;
      }

      this.loading = true;

      try {
        await shopkeeperAppApi.post(
          '/integration/anti-fraud/clearsale/credentials',
          {
            construpUserId: this.dadosUsuario.id,
            name: this.fields.name,
            password: this.fields.password,
            appKey: this.fields.appKey,
          }
        );

        this.makeToast('Sucesso', 'Credenciais salvas com sucesso', 'success');

        this.$emit('refresh');
        this.close();
      } catch (ex) {
        this.makeToast(
          'Erro',
          `Erro ao salvar as credenciais: ${ex.message}`,
          'danger'
        );
      } finally {
        this.loading = false;
      }
    },
    validateFields() {
      let isValid = true;

      if (!this.fields.password) {
        this.errorMessages.password = 'A senha é obrigatória';
        isValid = false;
      } else {
        this.errorMessages.password = '';
      }

      if (!this.fields.name) {
        this.errorMessages.name = 'O nome é obrigatório';
        isValid = false;
      } else {
        this.errorMessages.name = '';
      }

      if (!this.fields.appKey) {
        this.errorMessages.appKey = 'O fingerprint é obrigatório';
        isValid = false;
      } else {
        this.errorMessages.appKey = '';
      }

      return isValid;
    },
  },
  components: {
    InputPassword,
  },
};
</script>
